<div class="container">
  <div id="mainDiv" class="main-div form-div">
    <div class="form-row">
      <div class="input-group">
        <label>Timbrado</label>
        <input type="text" pInputText placeholder="Timbrado" />
      </div>
      <div class="input-group">
        <label>Autorização</label>
        <input type="text" pInputText placeholder="Autorização" />
      </div>
      <div class="input-group">
        <label>Ponto de Expedição</label>
        <input type="number" pInputText placeholder="Ponto de Expedição" />
      </div>
      <div class="input-group">
        <label>Número Filial</label>
        <input type="number" pInputText placeholder="Número Filial" />
      </div>
      <div class="input-group">
        <label>Próximo Número</label>
        <input type="number" pInputText placeholder="Próximo Número" />
      </div>
      <div class="input-group">
        <label>Número Máximo</label>
        <input type="number" pInputText placeholder="Número Máximo" />
      </div>
    </div>
    <div class="form-row">
      <div class="input-group">
        <label>Tipo de Transação</label>

      </div>
      <div class="input-group">
        <label>Tipo Nota</label>

      </div>
    </div>
    <div class="form-row">
      <div class="input-group">
        <p-button styleClass="button-enviar" label="Enviar" icon="pi pi-check"></p-button>
      </div>
    </div>
  </div>
</div>
